import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
  Text,
} from "@chakra-ui/react";
import { KYDEvent } from "@common/interfaces/KYDEvent";
import { useForm } from "react-hook-form";
import * as y from "yup";

const CreateEventSchema = y.object({
  name: y.string().required(),
  display_mode: y.mixed<KYDEvent["display_mode"]>().oneOf(["rsvp", "normal"]),
});

export type CreateEventValues = y.InferType<typeof CreateEventSchema>;

const CreateEventModal = ({ onClose, isOpen, isLoading, onSave }) => {
  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm<CreateEventValues>();
  const onSubmit = (data: CreateEventValues) => {
    // console.log(data);
    onSave(data);
  };

  return (
    <Modal
      size={"xl"}
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create Event</ModalHeader>
        <ModalBody>
          <Stack spacing={6}>
            <Stack>
              <Text fontWeight={"medium"}>Name</Text>
              <Input
                placeholder="Event name"
                isDisabled={isLoading}
                {...register("name")}
              />
            </Stack>
            <Stack>
              <Text fontWeight={"medium"}>Event Type</Text>
              <Select
                maxW={"200px"}
                defaultValue={"normal"}
                {...register("display_mode")}
              >
                <option value="normal">Paid Event</option>
                <option value="rsvp">RSVP Event</option>
              </Select>
            </Stack>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button
            isDisabled={isLoading}
            onClick={() => {
              onClose();
            }}
            mr="4"
          >
            Cancel
          </Button>
          <Button
            isDisabled={isLoading || !isValid}
            bg="blue.500"
            color="white"
            type="submit"
            isLoading={isLoading}
            onClick={handleSubmit(onSubmit)}
          >
            Create
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CreateEventModal;
